import { useSearchParams } from 'react-router-dom';

/**
 * Hook that provides utility functions for the check-in process
 */
export function useCheckInUtils() {
  const [searchParams] = useSearchParams();
  const isParentMode = searchParams.get('parent') === '1';
  // Allow ?force=YYYY-MM-DD to override which date's sessions are shown
  const forceDate = searchParams.get('force');

  /**
   * Converts sex value to display format (Boys/Girls)
   */
  function convertSex(sex: string): string {
    if (sex === 'male') return 'Boys';
    if (sex === 'female') return 'Girls';
    return sex;
  }

  /**
   * Converts time to AM/PM format
   */
  function convertToAmPm(time24: string): string {
    if (!time24) return '';
    const [h, m] = time24.split(':');
    let hour = parseInt(h, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${m} ${period}`;
  }

  return {
    isParentMode,
    forceDate,
    convertSex,
    convertToAmPm
  };
}
